<template>
  <div class="tabs">
    <ul>
      <!-- profile -->
      <li :class="navIsActive(`/members/${member.uid}`)">
        <Link v-t="'members.nav.profile'" :href="`/members/${member.uid}`"></Link>
      </li>

      <!-- events of member -->
      <li :class="navIsActive(`/members/${member.uid}/events`)">
        <Link :href="`/members/${member.uid}/events`">
          {{ $t('members.nav.events') }}
          ({{ member.events_count }})
        </Link>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { onUpdated } from 'vue'
import { initDropdowns } from 'flowbite'

defineProps({
  member: { type: Object, required: true }
})

// initialize components based on data attribute selectors
onUpdated(() => {
  initDropdowns()
})
</script>
